/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_D1dInputs */

const en_mk_sol_operasional_d1d = /** @type {(inputs: Mk_Sol_Operasional_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A scheduled routine runs the daily step at the same hour, and it is visible when it does not.`)
};

const id_mk_sol_operasional_d1d = /** @type {(inputs: Mk_Sol_Operasional_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutinitas terjadwal menjalankan langkah harian pada jam yang sama, dan gagalnya terlihat kalau tidak jalan.`)
};

/**
* | output |
* | --- |
* | "A scheduled routine runs the daily step at the same hour, and it is visible when it does not." |
*
* @param {Mk_Sol_Operasional_D1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_d1d = /** @type {((inputs?: Mk_Sol_Operasional_D1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_D1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_d1d(inputs)
	return en_mk_sol_operasional_d1d(inputs)
});